import messagesCo from './co.json';
import messagesCl from './cl.json';
import messagesPe from './pe.json';
import formatter from 'helpers/formatter';

const globalMsg: any = {
  cl: messagesCl,
  co: { ...messagesCl, ...messagesCo },
  pe: { ...messagesCl, ...messagesPe }
};

export default globalMsg[formatter.getCountry()] || globalMsg['cl'];
